module.exports = __webpack_public_path__ + "static/media/home-hero-desktop.af4af5cf.jpg";